import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { t } from "@/lib/i18n";
import { ReportDialog } from "@/components/ReportDialog";

export const Footer = ({ slug }) => {
  const [company, setCompany] = useState(null);

  useEffect(() => {
    api.get("/legal/company").then(({ data }) => setCompany(data.company)).catch(() => {});
  }, []);

  return (
    <footer className="mt-16 border-t border-[#E8DEC2] py-8" data-testid="site-footer">
      <div className="max-w-2xl mx-auto px-4 flex flex-col gap-4 text-sm text-[#7A6B63]">
        {company && (
          <p className="leading-relaxed" data-testid="footer-legal">
            {t("footer.legalPre", { name: company.name, cif: company.cif, address: company.address })}{" "}
            <a href={`mailto:${company.email}`} className="hover:text-[#B35A3E] hover:underline">{company.email}</a>
          </p>
        )}
        <div className="flex items-center gap-4">
          <Link to="/tietosuoja" className="hover:text-[#B35A3E] hover:underline" data-testid="footer-privacy-link">
            {t("footer.privacy")}
          </Link>
          <Link to="/kayttoehdot" className="hover:text-[#B35A3E] hover:underline" data-testid="footer-terms-link">
            {t("footer.terms")}
          </Link>
          <ReportDialog slug={slug} />
        </div>
      </div>
    </footer>
  );
};
